import React, { useEffect, useState } from 'react';
import { IonNote } from '@ionic/react';
import { Components } from '@ionic/core/components';
import { TextFieldTypes } from '@ionic/core';
import { Form } from 'types/app';
import {
  IonInputStyled,
  IonInputWrapper,
  IonItemWrapper,
} from 'components/common/form/textfield/Textfield.styled';
import FormLabel from 'components/common/form/label/FormLabel';

export interface TextfieldProps
  extends Pick<Components.IonInput, 'inputmode' | 'required' | 'name' | 'color'> {
  label?: string;
  value?: Form.IValue;
  onChange?: (value?: Form.IValue) => void;
  errorMessage?: string | null;
  type?: TextFieldTypes;
}

const Textfield: React.FC<TextfieldProps> = ({
  label,
  type,
  required,
  value,
  inputmode,
  errorMessage,
  onChange,
}: TextfieldProps) => {
  const [fieldValue, setFieldValue] = useState<Form.IValue>(value);
  const [isTouched, setIsTouched] = useState(false);
  const markTouched = () => {
    setIsTouched(true);
  };

  useEffect(() => {
    setFieldValue(value);
  }, [value]);

  return (
    <IonInputWrapper>
      <IonItemWrapper
        lines="none"
        className={`${errorMessage && 'ion-invalid'} ${isTouched && 'ion-touched'}`}
      >
        {label && <FormLabel label={label} required={required} />}
        <IonInputStyled
          type={type}
          required={required}
          inputmode={inputmode}
          onIonChange={(e) => {
            onChange && onChange(e.target.value);
            setFieldValue(e.target.value);
          }}
          onIonBlur={() => markTouched()}
          value={fieldValue as Form.IValueBase}
        />
        <IonNote slot="error">{errorMessage}</IonNote>
      </IonItemWrapper>
    </IonInputWrapper>
  );
};

export default Textfield;
